// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import {
  PlasmicProductCard,
  DefaultProductCardProps
} from "./plasmic/paziresh_24_search/PlasmicProductCard";
import { HTMLElementRefOf } from "@plasmicapp/react-web";
import { applyDoctorPresence } from "@/modules/search/components/productCard/doctorPresence";
import { useDoctorPresence } from "@/modules/search/hooks/useDoctorPresence";
import { useProgressiveMount } from "@/common/hooks/useProgressiveMount";
import { getSpecialtyIcon } from "@/modules/search/functions/specialtyIcon";
import Link from "next/link";

/** Rendered card height on mobile (measured 2026-09-26); keeps scroll position stable. */
const CARD_PLACEHOLDER_HEIGHT = 325;

export interface ProductCardProps extends DefaultProductCardProps {}

function ProductCard_(props: ProductCardProps, ref: HTMLElementRefOf<"div">) {
  // حضورِ پزشک (نقطه‌ی سبز + «X پیش آنلاین بوده») تا امروز با یک اسکریپتِ تزریقیِ خارجی روی
  // DOMِ همین کارت می‌نشست. حالا بومی است: داده batch گرفته می‌شود و فقط روی ریشه‌ی همین کارت
  // اعمال می‌شود. جزئیات در `src/modules/search/components/productCard/doctorPresence.ts`.
  const cardRef = React.useRef<HTMLDivElement | null>(null);
  const slug = (props as { slug?: string }).slug;
  const presence = useDoctorPresence(slug);

  const setRefs = React.useCallback(
    (node: HTMLDivElement | null) => {
      cardRef.current = node;
      if (typeof ref === "function") ref(node);
      else if (ref) (ref as React.MutableRefObject<HTMLDivElement | null>).current = node;
    },
    [ref]
  );

  React.useEffect(() => {
    applyDoctorPresence(cardRef.current, presence, slug);
  });

  // Client-side lists mount only the first cards immediately; the rest upgrade one per
  // frame after paint (SSR/hydration always full). See docs/performance.md §۳.۳.
  const mounted = useProgressiveMount();
  const specialtyIcon = getSpecialtyIcon(props.url?.destination);
  if (specialtyIcon) {
    return (
      <div ref={setRefs} className="w-full overflow-hidden rounded-lg bg-white">
        <Link
          href={props.url.destination}
          title={props.url.title}
          target={props.url.openInNewTab}
          onClick={() => props.eventTrigger?.("title", props.title ?? "")}
          className="flex min-h-16 w-full items-center gap-3 px-4 py-3 text-right text-slate-900 active:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-500"
        >
          <img src={specialtyIcon} alt="" width={40} height={40} loading="lazy" decoding="async" className="h-10 w-10 shrink-0 object-contain" />
          <h2 className="min-w-0 flex-1 text-sm font-semibold leading-6">{props.title}</h2>
        </Link>
      </div>
    );
  }
  if (!mounted) {
    return <div data-card-placeholder aria-hidden style={{ minHeight: CARD_PLACEHOLDER_HEIGHT }} />;
  }

  return <PlasmicProductCard root={{ ref: setRefs, "data-doctor-slug": slug }} {...props} />;
}

const ProductCard = React.forwardRef(ProductCard_);
export default ProductCard;
